import React from 'react';
import { FormControlLabel, Radio } from '@material-ui/core';

/** Renders a reusable radio option with optional description and page-specific styling hooks. */
const RadioOption = ({ value, label, description, selected, onChange, disabled = false, className = '' }) => (
    <FormControlLabel
        className={className}
        disabled={disabled}
        style={{
            ...(description ? { alignItems: 'flex-start' } : {}),
            cursor: disabled ? 'not-allowed' : 'pointer',
        }}
        value={value}
        control={<Radio checked={selected} onChange={onChange} style={{ cursor: disabled ? 'not-allowed' : 'pointer' }} />}
        label={
            <span style={{ display: 'inline-block', paddingTop: description ? '10px' : '0' }}>
                <span className="restorative-option-label">{label}</span>
                {description && <span className="restorative-option-description">{description}</span>}
            </span>
        }
    />
);

export default RadioOption;
